var _defs, _circle, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        fill: #c55d6c;\n      }\n\n      .st2 {\n        fill: #fff;\n      }\n\n      .st3 {\n        fill: #cf666c;\n      }\n\n      .st4 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 48,
    y: 48,
    width: 120,
    height: 120
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 108,
    cy: 108,
    r: 108
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M108,0C66.4,0,30.3,23.5,12.3,58c18,34.5,54.1,58,95.7,58s77.7-23.5,95.7-58C185.7,23.5,149.6,0,108,0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M108,158c-9.8,0-18-3.4-24.8-10.2s-10.2-15.1-10.2-24.8,1.2-10.1,3.5-14.4c2.3-4.4,6.1-9.3,11.4-14.8,5.6-5.8,8.9-11.4,9.8-16.6,1-5.2,1.4-11.6,1.2-19.2,13.6,8.4,24.3,18.5,32.2,30.2,7.9,11.7,11.9,23.3,11.9,34.8s-3.4,18-10.2,24.8-15.1,10.2-24.8,10.2ZM108,150.5c2.1,0,4.1-.8,6-2.4s2.9-4.1,2.9-7.5-.6-5-1.9-8.6c-1.3-3.5-3.6-7.4-6.9-11.7-3.2,4.1-5.4,7.9-6.7,11.6-1.3,3.6-1.9,6.5-1.9,8.7,0,3.3,1,5.8,2.9,7.4,1.8,1.6,3.8,2.4,5.8,2.4h-.2ZM92.4,146c-.9-4.8-.3-10.3,1.8-16.3,2.1-6,5.8-11.8,11.1-17.3.4-.4.9-.7,1.4-.9.5-.2,1-.3,1.4-.3s1,0,1.4.3c.5.2.9.5,1.3.9,2.2,2.2,4.2,4.7,6.1,7.4,1.9,2.7,3.4,5.4,4.7,8.3,1.2,2.9,2.1,5.8,2.6,8.9.5,3,.4,6.1-.2,9.1,3.1-2.2,5.8-5.3,8.1-9.5s3.5-8.7,3.5-13.5-1-10.2-2.9-15.2-4.3-9.6-7.2-14c-2.9-4.4-6-8.4-9.5-12.1s-6.7-6.9-9.8-9.4c-.4,5.5-1.7,10.3-3.9,14.4-2.2,4.1-5.3,8.4-9.5,12.9-4.2,4.6-7.4,8.5-9.3,11.9s-2.9,7.2-2.9,11.5,1.1,9.1,3.3,13.1c2.2,4,5.1,7.3,8.6,9.9h-.1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.2497d3276b1764de5e05ccdd9d8b7503.svg";
export { ForwardRef as ReactComponent };